import { ISolicitudAmpliacionAprobacionModel, ISolicitudesAmpliacionAprobacionModel } from "../interfaces/calendario-sso/ISolicitudAmpliacionAprobacionModel";

export class SolicitudAmpliacionAprobacionModel implements ISolicitudAmpliacionAprobacionModel {
    idSolicitudAmpliacionSso: number;
    aprobado: boolean;
    desaprobado: boolean;
    constructor(){
        this.idSolicitudAmpliacionSso = 0;
        this.aprobado = false;
        this.desaprobado = false;   
    }
}

export class SolicitudesAmpliacionAprobacionModel implements ISolicitudesAmpliacionAprobacionModel {
    listaSolicitudes: SolicitudAmpliacionAprobacionModel[];
    nuevoPlazo?: Date;
    comentarios: string;
    plazoAnterior?: Date;
    
    constructor(){
        this.listaSolicitudes = new Array<SolicitudAmpliacionAprobacionModel>();
        this.comentarios = '';
    }
}